if (!customElements.get('review-carousel')) {
  class ReviewCarousel extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-track]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.slides = [...this.track.children];
      this.index = 0;
      this.startX = 0;
      this.dragging = false;
    }

    connectedCallback() {
      if (this.slides.length < 2) return;

      this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
      this.nextBtn.addEventListener('click', () => this.go(this.index + 1));

      this.track.addEventListener('touchstart', (e) => {
        this.startX = e.touches[0].clientX;
        this.dragging = true;
      }, { passive: true });

      this.track.addEventListener('touchend', (e) => {
        if (!this.dragging) return;
        this.dragging = false;
        const diff = this.startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          this.go(this.index + (diff > 0 ? 1 : -1));
        }
      });

      this.go(0);
    }

    go(i) {
      this.index = ((i % this.slides.length) + this.slides.length) % this.slides.length;
      const slide = this.slides[this.index];
      const pad = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
      this.track.style.transform = `translateX(-${slide.offsetLeft - pad}px)`;
    }
  }

  customElements.define('review-carousel', ReviewCarousel);
}
